import { render } from "./about.vue?vue&type=template&id=4fec8d96&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.scss?vue&type=style&index=0&id=4fec8d96&lang=scss&scoped=true"

import exportComponent from "/Users/yue/Documents/其他项目/数字转创/official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fec8d96"]])

export default __exports__